import {z} from '@hono/zod-openapi';

export const ISSUE_REPORT_SEVERITIES = ['blocking', 'degraded', 'cosmetic'] as const;

export const issueReportSeveritySchema = z
  .enum(ISSUE_REPORT_SEVERITIES)
  .openapi('IssueReportSeverity');

export type IssueReportSeverity = z.infer<typeof issueReportSeveritySchema>;
